/**
 * @name: tradingRules.js
 * @description: 交易规则路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/transaction/order/list',
    name: 'orderManagement',
    component: () => import('@/views/transaction/order/List'),
    meta: {
      title: '订单列表'
    }
  },
  {
    path: '/transaction/order/detail',
    name: 'orderDetail',
    component: () => import('@/views/transaction/order/Detail'),
    meta: {
      title: '订单详情',
      parentRoutePath: 'orderManagement'
    }
  },
  {
    path: '/transaction/order/refund',
    name: 'orderRefund',
    component: () => import('@/views/transaction/order/Refund'),
    meta: {
      title: '退款截图',
      parentRoutePath: 'orderManagement'
    }
  },
  {
    path: '/transaction/warehouse/list',
    name: 'warehouseManagement',
    component: () => import('@/views/transaction/warehouse/List'),
    meta: {
      title: '仓库设置'
    }
  },
  {
    path: '/transaction/warehouse/add',
    name: 'warehouseAdd',
    component: () => import('@/views/transaction/warehouse/Add'),
    meta: {
      title: '新增仓库设置',
      parentRoutePath: 'warehouseManagement'
    }
  },
  {
    path: '/transaction/freight/list',
    name: 'freightManagement',
    component: () => import('@/views/transaction/freight/List'),
    meta: {
      title: '运费模板设置'
    }
  },
  {
    path: '/transaction/freight/add',
    name: 'freightAdd',
    component: () => import('@/views/transaction/freight/Add'),
    meta: {
      title: '添加运费模板设置',
      parentRoutePath: 'freightManagement'
    }
  },
  {
    path: '/transaction/placeorder/list',
    name: 'placeOrderManagement',
    component: () => import('@/views/transaction/placeOrder/List'),
    meta: {
      title: '下单规则设置'
    }
  },
  {
    path: '/transaction/placeorder/add',
    name: 'placeOrderAdd',
    component: () => import('@/views/transaction/placeOrder/Add'),
    meta: {
      title: '添加下单规则设置',
      parentRoutePath: 'placeOrderManagement'
    }
  },
  {
    path: '/transaction/switch/list',
    name: 'switchManagement',
    component: () => import('@/views/transaction/switch/List'),
    meta: {
      title: '下单开关'
    }
  },
  {
    path: '/transaction/switch/add',
    name: 'switchAdd',
    component: () => import('@/views/transaction/switch/Add'),
    meta: {
      title: '新增下单开关',
      parentRoutePath: 'switchManagement'
    }
  },
  {
    path: '/transaction/blacklist/list',
    name: 'blacklistManagement',
    component: () => import('@/views/transaction/blacklist/List'),
    meta: {
      title: '黑名单管理'
    }
  },
  {
    path: '/transaction/message/list',
    name: 'messageManagement',
    component: () => import('@/views/transaction/message/List'),
    meta: {
      title: '消息列表'
    }
  }, {
    path: '/transaction/message/detail',
    name: 'messageDetail',
    component: () => import('@/views/transaction/message/Detail'),
    meta: {
      title: '消息详情',
      parentRoutePath: 'messageManagement'
    }
  },
];
